// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__QuWH2","tabs":"style_tabs__3HsKs","item":"style_item__2cOms","active":"style_active__3EdcL","box":"style_box__1cPfJ"};